import React, { useState, useMemo } from 'react';
import { useIsSSR } from 'react-aria';
import { Select as Select$1, Button, SelectValue, Popover, ListBox } from 'react-aria-components';
import { clsx } from 'clsx';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';
import { SelectGroup } from './SelectGroup.es.js';
import { SelectItem } from './SelectItem.es.js';
import { VisuallyHidden, Icon, Shadows } from '@zapier/design-system';
import { SelectContext } from './SelectContext.es.js';

const select = "_select_y9j48_1";
const selectTrigger = "_select-trigger_y9j48_10";
const selectValue = "_select-value_y9j48_42";
const popover = "_popover_y9j48_59";
const listBox = "_list-box_y9j48_73";
const styles = {
	select: select,
	selectTrigger: selectTrigger,
	selectValue: selectValue,
	popover: popover,
	listBox: listBox
};

const Select = ({ "aria-describedby": ariaDescribedBy, "aria-details": ariaDetails, children, className, defaultSelectedValue, isDisabled = false, errorMessage, helpText, isInvalid = false, isLabelHidden = false, isOpen, isRequired = false, label, onBlur, onFocus, onFocusChange, onKeyDown, onKeyUp, onOpenChange, onValueChange, placeholder, selectedValue, size = "medium" }) => {
  const isSSR = useIsSSR();
  const [disabledKeys, setDisabledKeys] = useState([]);
  const registerDisabledItem = useMemo(() => ({
    registerDisabledItem: (id) => {
      setDisabledKeys((prev) => [...prev, id]);
    }
  }), []);
  if (isSSR) {
    return null;
  }
  return React.createElement(
    SelectContext.Provider,
    { value: registerDisabledItem },
    React.createElement(
      Select$1,
      { "aria-details": ariaDetails, "aria-describedby": ariaDescribedBy, className: clsx(className, styles.select), "data-zds": true, defaultSelectedKey: defaultSelectedValue, disabledKeys, isDisabled, isInvalid, isOpen, onBlur, onFocus, onFocusChange, onKeyDown, onKeyUp, onOpenChange, onSelectionChange: onValueChange, placeholder, selectedKey: selectedValue, isRequired },
      isLabelHidden ? React.createElement(
        VisuallyHidden,
        null,
        React.createElement(Label, null, label)
      ) : React.createElement(Label, { isCompact: size === "compact", isRequired, isDisabled, isInvalid }, label),
      React.createElement(
        Button,
        { className: styles.selectTrigger, "data-size": size, "data-zds": true },
        React.createElement(SelectValue, { "data-size": size, className: styles.selectValue, "data-zds": true }),
        React.createElement(Icon, { name: "arrowDropdown", color: "TextWeaker", size: size === "compact" ? 20 : 24 })
      ),
      isInvalid && errorMessage ? React.createElement(ErrorMessage, { isCompact: size === "compact" }, errorMessage) : helpText && React.createElement(Description, { isCompact: size === "compact" }, helpText),
      React.createElement(
        Popover,
        { className: styles.popover, style: {
          "--popover-shadow": Shadows.elevation20
        }, "data-zds": true },
        React.createElement(ListBox, { className: styles.listBox, "data-zds": true }, children)
      )
    )
  );
};
Select.Item = SelectItem;
Select.Group = SelectGroup;

export { Select };
//# sourceMappingURL=Select.es.js.map
